splitDateString